<template>
    <div>

      <report-window endpoint="/reports/sales_by_paymentmethod" :fields="fields" :title="title" :headers="headers"
      :templates="templates" :columnsClasses="columnsClasses"></report-window>

    </div>
</template>

<script>
import '@/css/app.css';

import ReportWindow from '@/components/tools/ReportWindow'
import { mapState } from 'vuex';
var moment = require('moment');
export default {
  name: 'salesbypaymentmethod',
  components: {

    ReportWindow,
  },
  computed: {
    ...mapState({
        user: state => state.user,
    }),
  },
  data () {
    return {
        fields: [
        {name: 'FromDate', editor: 'date', label: 'Desde', defValue: moment(new Date()).format("YYYY-MM-DD")
            , required: true, columns: 1},
        {name: 'ToDate', editor: 'date', label: 'Hasta', defValue:  moment(new Date()).format("YYYY-MM-DD")
            , required: true, columns: 1},
        {name: 'PaymentMethodCode', relation: 'paymentmethod', optionLabels: 'Name', id: 'PaymentMethodCode'
            , editor: 'select', label: 'Medio de Pago'},
        {name: 'InstallmentsDetail', label: 'Detalle por Cuotas', editor: 'select', defValue: '0',
            options: [
                {value: '0', label: 'No'},
                {value: '1', label: 'Si'},
                ]},
         ],
        title: 'Ventas por Medio de Pago',
        headers: {Amount: 'Monto', PaymentMethodCode: 'Medio de Pago', Installments: 'Cuotas'},
        templates: [
            {name: 'Amount', callback (row) {return app.numberFormat(parseFloat(row.Amount));}},
        ],
        columnsClasses: {Amount: 'text-right'},

    }
  },
}
</script>

